export default __webpack_public_path__ + "static/media/mainIMG.9361887f.jpg";